// extracted by css-extract-rspack-plugin
export default {"OptionsHeading":"single-select-options-module__OptionsHeading__Lol6S","SingleSelectForm":"single-select-options-module__SingleSelectForm__D73PD"};